import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import {
  createScaffolderFieldExtension,
  type FieldExtensionOptions,
} from '@backstage/plugin-scaffolder-react';
import { GitHubOAuthField } from './GitHubOAuthFieldExtension';
import { validateGithubTokenField } from '../githubAccessValidation';

// Exported as plain options as well as a provided extension. The stock /create
// route registers the extension as a React child; anything rendering a
// template outside that route needs the options (see ../extensions.ts).
export const gitHubOAuthFieldOptions: FieldExtensionOptions<any, any> = {
  name: 'GitHubOAuthField',
  component: GitHubOAuthField,
  validation: validateGithubTokenField,
};

export const GitHubOAuthFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension(gitHubOAuthFieldOptions),
);
